import { AppState } from './App'
import './DeleteAccount.css'; // make sure to create a CSS file with the name 'DeleteAccount.css'
import { customList, CountryProperty } from 'country-codes-list'
import { getApi } from './Api'
import { AuthenticateUser400Response, AuthenticateUser403Response, AuthenticateUserRequest } from './api/api';
import axios, { AxiosResponse } from 'axios';
import React from 'react';

const INITIAL_PHONE_NUMBER = '5145550050'

interface ComponentProps {
	changeState: (newState: AppState) => void
	handleOutput: (output: string) => void
}

type State = {
	countryCode: string
	phoneNumber: string
	isPhoneNumberValid: boolean
	buttonDisabled: boolean
	showError: boolean
}
export default class DeleteAccount extends React.Component<ComponentProps, State> {

	state: State

	constructor(props: ComponentProps) {
		console.log('DeleteAccount')
		super(props)
		this.state = {
			countryCode: '+1',
			phoneNumber: '',
			isPhoneNumberValid: false,
			buttonDisabled: true,
			showError: false
		}
	}

	componentDidMount() {
		this.setPhoneNumber(INITIAL_PHONE_NUMBER)
	}

	doLogin = (e: React.FormEvent) => {
		console.log('doLogin')
		e.preventDefault();
		this.setState({ showError: true })
		if (!this.state.isPhoneNumberValid) {
			// Handle invalid phone number case (e.g., show error message to user)
			console.error("Invalid phone number");
			return;
		}
		const api = getApi()
		const req: AuthenticateUserRequest = {
			countryCode: this.state.countryCode,
			phoneNumber: this.state.phoneNumber
		}
		api.authenticateUser(req).then(
			(resp: AxiosResponse) => {
				console.log('authenticateUser success')
				this.props.handleOutput(`${this.state.countryCode}${this.state.phoneNumber}`)
				this.props.changeState(AppState.STATE_PROVIDE_OTP)
			}).catch((error: any) => {
				if (axios.isAxiosError(error)) {
					// Now you can access error.response
					if (error.response) {
						switch (error.response.status) {
							case 400:
								const errorData400 = error.response.data as AuthenticateUser400Response;
								console.log('400 Error: ', errorData400);
								break;
							case 403:
								const errorData403 = error.response.data as AuthenticateUser403Response;
								console.log('403 Error: ', errorData403);
								this.props.changeState(AppState.STATE_TOO_MANY_ATTEMPTS)
								break;
							default:
								// Handle other errors
								console.log('Other Error: ', error.response.data);
						}
					} else {
						// The request was made but no response was received
						console.log('Error: No response received', error.message);
					}
				} else {
					// Something happened in setting up the request and triggered an Error
					console.log('Error: ', error.message);
				}
			})
		// api.
	}

	validatePhoneNumber = (phoneNumber: string) => {
		const isPhoneNumberValid = phoneNumber !== '' && /^\d+$/.test(phoneNumber);
		console.log(`isPhoneNumberValid ${isPhoneNumberValid}`)
		this.setState({ isPhoneNumberValid, buttonDisabled: !isPhoneNumberValid });
		return isPhoneNumberValid
	};

	setCountryCode(countryCode: string) {
		this.setState({ countryCode })
	}

	setPhoneNumber(phoneNumber: string) {
		console.log(`setPhoneNumber(${phoneNumber})`)
		this.setState({ phoneNumber })
		this.validatePhoneNumber(phoneNumber)
	}

	render() {
		const countryCodes: { [key: string]: string } = customList('countryNameLocal' as CountryProperty, '{countryCallingCode}')
		const callingCodes = Object.values(countryCodes).filter(cc => cc !== '0').sort()
		const unique = Array.from(new Set(callingCodes)).filter((el) => typeof (el) === 'string')
		const optionTemplate = unique.map(cc => (
			// <option value={`+${cc}`}>{`+${cc}`} {(this.countryCodes[cc] as string)}</option>
			<option key={cc} value={`+${cc}`}>{`+${cc}`}</option>
		));

		return (
			<div className="delete-account-container">
				<div className="delete-account-card">
					<form>
						<div className="logos">
							{/* Add your logos here */}
						</div>
						<h1>Delete Your Odience and Verse Account</h1>
						<div className="message">We're sorry to see you go. To begin, please log in to your account.</div>
						{this.state.showError && !this.state.isPhoneNumberValid && <div className="error-message">Invalid phone number</div>}
						<div className="input-label">Mobile Phone Number</div>
						<div className="input-container">
							<select className="country-code" onChange={(e) => this.setCountryCode(e.target.value)}>
								{optionTemplate}
							</select>
							<input type="text" className="phone-number" placeholder="555-567-8910"
								value={this.state.phoneNumber}
								onChange={(e) => this.setPhoneNumber(e.target.value)} />
						</div>
						<button type="submit"
							disabled={this.state.buttonDisabled}
							onClick={this.doLogin}>Log in to account</button>
					</form>
				</div>
			</div>
		);
	}
};
